module.exports = __webpack_public_path__ + "static/media/alfa.961ac3ff.png";